import { get, post } from "./Api";

export function CreateArticlePoint({ data }) {
  return post({ url: `/createArticlePoint`, data });
}